import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getRoundtrips } from '../../../store/actions/app/roundtrip';

import CompanyProgress from '../MyCompany/CompanyProgress';
import Card from '../UI/Card';
import CreateButton from '../UI/CreateButton';
import Loader from '../UI/Loader';

import iRoundtrips from '../../../assets/icons/left-drawer-roundtrip-orange.svg';
import ScrollToTopOnMount from '../../../helpers/ScrollToTop';
import SubscribeGateway from '../../Modals/AuthGatewayModals/SubscribeGateway';
import ProGateway from '../../Modals/AuthGatewayModals/ProGateway';
import LeftDrawer from '../Drawers/LeftDrawer';
import Screen from '../Screen/Screen';
import Navbar from '../Navbar/';
import { isBrowser } from 'react-device-detect';
import Minimessages from '../Messages/Minimessages';
import DashboardFooter from '../DashboardFooter';

const Main = (props) => {
  const [isExpired, setIsExpired] = useState(false);
  const [isRegular, setIsRegular] = useState(false);
  const [expiredModal, setExpiredModal] = useState(false);
  const [regularModal, setRegularModal] = useState(false);
  const dispatch = useDispatch();
  const USER = useSelector((state) => state.dashboard.user?.data);
  const COMPANY = useSelector((state) => state.dashboard.company?.data);
  const USER_PLAN = useSelector(
    (state) => state.dashboard.company?.data?.activeSubscription
  );
  const SUBSCRIPTION_NAME = useSelector(
    (state) => state.dashboard.company?.data?.subscriptionPlan?.subscriptionName
  );
  const LATEST_ROUNDTRIPS = useSelector((state) => state.app.roundtrip?.data);

  useEffect(() => {
    // Get roundtrips if they don't already exist
    if (!LATEST_ROUNDTRIPS) {
      dispatch(getRoundtrips());
    }
  }, [LATEST_ROUNDTRIPS, dispatch]);

  // Set subscription barrier
  /*   useEffect(() => {
    if (typeof USER_PLAN !== 'undefined' && !USER_PLAN) setIsExpired(true);
  }, [USER_PLAN]); */

  useEffect(() => {
    if (
      (SUBSCRIPTION_NAME !== 'undefined' &&
        SUBSCRIPTION_NAME !== 'Roundtrip Pro') ||
      (typeof USER_PLAN !== 'undefined' && !USER_PLAN)
    ) {
      setIsRegular(true);
    }
  }, [SUBSCRIPTION_NAME, USER_PLAN]);

  return (
    <>
      <Screen>
        <ScrollToTopOnMount />
        <Navbar />
        {USER && USER.privileges === 'Admin' && (
          <CompanyProgress COMPANY={COMPANY} USER={USER} />
        )}
        <div className="Card-inline">
          <Card title="Latest roundtrips" icon={iRoundtrips}>
            {LATEST_ROUNDTRIPS ? (
              <div className="Latest">
                {LATEST_ROUNDTRIPS.slice(0, 3).map((roundtrip) => {
                  return (
                    <Link
                      to={{
                        pathname: '/roundtrip',
                        state: {
                          sheet: roundtrip._id,
                        },
                      }}
                      key={roundtrip._id}
                    >
                      <h5>{roundtrip.name}</h5>
                    </Link>
                  );
                })}
              </div>
            ) : (
              !LATEST_ROUNDTRIPS && <Loader />
            )}

            {/* {props.ROUNDTRIPS_FETCH_ERROR && <ErrorClosure />} */}
            {!isExpired && !isRegular ? (
              <CreateButton
                centered
                title="Create Roundtrip"
                to="/dashboard/roundtrip/create"
              />
            ) : isRegular ? (
              <CreateButton
                centered
                title="Create Roundtrip"
                isButton
                onClick={() => setRegularModal(true)}
              />
            ) : (
              <CreateButton
                centered
                title="Create Roundtrip"
                isButton
                onClick={() => setExpiredModal(true)}
              />
            )}
            <div className="all-button">
              <Link to="/roundtrip">All roundtrips</Link>
            </div>
          </Card>
          <Card title="Latest roundtrip requests" icon={iRoundtrips}>
            {LATEST_ROUNDTRIPS ? (
              <div className="Latest">
                <h3>Find carriers for your roundtrip routes</h3>
                <p>Create a roundtrip request to connect with carriers who match your needs.</p>
              </div>
            ) : (
              !LATEST_ROUNDTRIPS && <Loader />
            )}

            {!isExpired && !isRegular ? (
              <CreateButton
                centered
                title="Create Roundtrip Request"
                to="/dashboard/find-roundtrip/create"
              />
            ) : isRegular ? (
              <CreateButton
                centered
                title="Create Roundtrip Request"
                isButton
                onClick={() => setRegularModal(true)}
              />
            ) : (
              <CreateButton
                centered
                title="Create Roundtrip Request"
                isButton
                onClick={() => setExpiredModal(true)}
              />
            )}
            <div className="all-button">
              <Link to="/find-roundtrip">All roundtrip requests</Link>
            </div>
          </Card>
        </div>
        <DashboardFooter />
      </Screen>
      {regularModal && <ProGateway onClose={() => setRegularModal(false)} />}
      {expiredModal && (
        <SubscribeGateway onClose={() => setExpiredModal(false)} />
      )}
      {isBrowser && <Minimessages />}
      <LeftDrawer />
    </>
  );
};

export default Main;
